import {
  GET_SETTINGS_DATA, GET_USER_API_KEY, RESET_USER_SETTINGS, EXPORT_USER_SETTINGS, IMPORT_USER_SETTINGS,
  RESET_USER_SETTINGS_EXPORT_FILE, RESET_USER_API_KEY,
} from '../../constants/system/actions';

const getSettingsData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_SETTINGS_DATA, payload, resolve, reject,
});

const getUserApiKey: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_USER_API_KEY, payload, resolve, reject,
});

const exportUserSettings: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: EXPORT_USER_SETTINGS, payload, resolve, reject,
});

const importUserSettings: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: IMPORT_USER_SETTINGS, payload, resolve, reject,
});

const resetUserApiKey: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_USER_API_KEY, payload,
});

const resetUserSettings: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: RESET_USER_SETTINGS, payload, resolve, reject,
});

const resetUserSettingsExportFile: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_USER_SETTINGS_EXPORT_FILE, payload,
});

export {
  getSettingsData,
  getUserApiKey,
  exportUserSettings,
  importUserSettings,
  resetUserApiKey,
  resetUserSettings,
  resetUserSettingsExportFile,
};
